/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_N6Inputs */

const en_to_xml_ref_n6 = /** @type {(inputs: To_Xml_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A name cannot start with a digit, so an underscore is prefixed.`)
};

const ko_to_xml_ref_n6 = /** @type {(inputs: To_Xml_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름은 숫자로 시작할 수 없으므로 밑줄이 앞에 붙습니다.`)
};

const ja_to_xml_ref_n6 = /** @type {(inputs: To_Xml_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前は数字で始められないので、アンダースコアが前に付きます。`)
};

/**
* | output |
* | --- |
* | "A name cannot start with a digit, so an underscore is prefixed." |
*
* @param {To_Xml_Ref_N6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_n6 = /** @type {((inputs?: To_Xml_Ref_N6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_N6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_n6(inputs)
	if (locale === "ko") return ko_to_xml_ref_n6(inputs)
	return ja_to_xml_ref_n6(inputs)
});